var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var symbols = new Map([
    ["+", "плюс"],
    ["$", "доллар"],
    ["%", "процент"],
    ["@", "собака"],
    ["<", "меньше"],
    [">", "больше"],
    ["=", "равно"],
]);
var hundreds = new Map([
    ["1", "сто"],
    ["2", "двести"],
    ["3", "триста"],
    ["4", "четыреста"],
    ["5", "пятьсот"],
    ["6", "шестьсот"],
    ["7", "семьсот"],
    ["8", "восемьсот"],
    ["9", "девятьсот"],
]);
var tens = new Map([
    ["1", "десять"],
    ["2", "двадцать"],
    ["3", "тридцать"],
    ["4", "сорок"],
    ["5", "пятьдесят"],
    ["6", "шестьдесят"],
    ["7", "семьдесят"],
    ["8", "восемьдесят"],
    ["9", "девяносто"],
]);
var nums = new Map([
    ["1", "один"],
    ["2", "два"],
    ["3", "три"],
    ["4", "четыре"],
    ["5", "пять"],
    ["6", "шесть"],
    ["7", "семь"],
    ["8", "восемь"],
    ["9", "девять"],
    ["10", "десять"],
    ["11", "одиннадцать"],
    ["12", "двенадцать"],
    ["13", "тринадцать"],
    ["14", "четырнадцать"],
    ["15", "пятнадцать"],
    ["16", "шестнадцать"],
    ["17", "семнадцать"],
    ["18", "восемнадцать"],
    ["19", "девятнадцать"],
]);
function numberToWords(number) {
    var word = "";
    if (number < 1000) {
        var h = Math.floor(number / 100);
        if (h)
            word += hundreds.get(h.toString()) + " ";
        number = number % 100;
        if (nums.has(number.toString())) {
            word += nums.get(number.toString());
            return word;
        }
        else {
            var t = Math.floor(number / 10);
            if (t)
                word += tens.get(t.toString()) + " ";
        }
        number = number % 10;
        if (nums.get(number.toString())) {
            word += nums.get(number.toString());
        }
    }
    else {
        word += numberToWords(Math.floor(number / 1000)) + " тысяч ";
        word += numberToWords(number % 1000);
    }
    return word;
}
export function countWords(text) {
    var e_1, _a, e_2, _b;
    try {
        for (var _c = __values(symbols.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2), symbol = _e[0], word = _e[1];
            text = text.replace(new RegExp("\\".concat(symbol), "g"), " ".concat(word, " "));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var numbers = text.match(/\d+/g);
    if (numbers) {
        try {
            for (var numbers_1 = __values(numbers), numbers_1_1 = numbers_1.next(); !numbers_1_1.done; numbers_1_1 = numbers_1.next()) {
                var number = numbers_1_1.value;
                text = text.replace(number, numberToWords(+number));
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (numbers_1_1 && !numbers_1_1.done && (_b = numbers_1.return)) _b.call(numbers_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    text = text
        .toLowerCase()
        .replace(/[^a-z а-я]/g, " ")
        .replace(/\s{2,}/g, " ")
        .trim();
    var words = text.split(/\s/);
    var smallWords = words.filter(function (word) { return word.length < 3; });
    var normalWords = words.filter(function (word) { return !smallWords.includes(word); });
    var smallWordsExtra = Math.floor(smallWords.reduce(function (acc, word) { return acc + word.length; }, 0) / 4);
    return normalWords.length + smallWordsExtra;
}
export function calcChronometry(text) {
    if (!text)
        return 0;
    return Math.ceil(countWords(text) / 2);
}
